// Centralized asset URLs uploaded by the customer
export const ASSETS = {
  logo:
    "https://customer-assets.emergentagent.com/job_3d2e4346-dd89-43e5-8844-3eb10858aae7/artifacts/x7nykpol_logo%20Nikola%20vino%201%20%281%29%20-%20Copy.png",
  heroBottle:
    "https://customer-assets.emergentagent.com/job_3d2e4346-dd89-43e5-8844-3eb10858aae7/artifacts/awcmtgu2_IMG-20260609-WA0010.jpg",
  vineyard:
    "https://customer-assets.emergentagent.com/job_3d2e4346-dd89-43e5-8844-3eb10858aae7/artifacts/i7hjgher_Screenshot_20260624_153135_Instagram%281%29.jpg",
  cratesBottles:
    "https://customer-assets.emergentagent.com/job_3d2e4346-dd89-43e5-8844-3eb10858aae7/artifacts/co1z4nnw_IMG-20260624-WA0021.jpg",
  barrelsCellar:
    "https://customer-assets.emergentagent.com/job_3d2e4346-dd89-43e5-8844-3eb10858aae7/artifacts/uzogaxeq_IMG-20260624-WA0013.jpg",
  corks:
    "https://customer-assets.emergentagent.com/job_oak-heritage-wines/artifacts/a7wazfdx_IMG-20260624-WA0014.jpg",
  merlotShot:
    "https://customer-assets.emergentagent.com/job_oak-heritage-wines/artifacts/47cyefrv_Screenshot_20260624_174902_Instagram.jpg",
  magicShot:
    "https://customer-assets.emergentagent.com/job_oak-heritage-wines/artifacts/p0i0cuao_Screenshot_20260624_175113_Instagram.jpg",
};
